// extracted by mini-css-extract-plugin
export default {"NewClassificationDialog":"NewClassificationDialog_NewClassificationDialog__I4P8j"};